import React from 'react';
import Reflux from 'reflux';
import './Comment.css';

class OpenGraphLoader extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            opengraph: this.props.opengraph || {}
        };
    }
    componentWillReceiveProps (newProps) {
        let opengraph = this.state.opengraph || newProps.opengraph;
        if (opengraph && opengraph.image) {
            this.setState({opengraph: opengraph});
        }
    }
    render () {
        let opengraph = this.state.opengraph;
        let opengraphData = opengraph.image
            ? <div>
              <a className='media-comment' href={opengraph.url} target='_blank'>
                <img className='responsive-img' src={opengraph.image} alt={opengraph.title} />
              </a>
            </div> : <div />;
        return opengraphData;
    }
}

export default OpenGraphLoader;



// WEBPACK FOOTER //
// ./src/sections/OpenGraphLoader.js